

import { defineComponent } from 'vue';
import { HEmpty } from "@nio-fe/horo-h5";
import styles from "./styles.module.scss"
// 引入当前品牌的样式文件
// import "@nio-fe/horo-h5/dist/style/components/empty/index.css";
// import "@nio-fe/horo-h5/dist/style/components/base-style/index.css";
/* eslint-disable-next-line */


export default defineComponent({
  name: 'EmptyContent',
  props: [ 'tips'],
  render(props: any) {
    return (
      <div  class={styles.empty}>
          <HEmpty class="h-empty"
          type={"fail_default"}
          title={props.tips||"暂无相关结果!"}
          />
      </div>
    );
  }
});
